import { Fragment } from "react";
import { signal } from "@preact/signals-react";

import TablesModal from "./TablesModal";

const openModal = signal(false);

function TableDisplay({ record }) {
  const shopId = record?.shop?.id ?? record?.shop;

  function onClose() {
    openModal.value = false;
  }

  function onClick() {
    openModal.value = true;
  }

  const name = record.table_assigned?.name || "Mesa";

  return (
    <Fragment>
      <div className="tablet:grid tablet:grid-rows tablet:py-2">
        <div
          className="flex h-12 w-full my-auto bg-blue-100 text-neutral-600 cursor-pointer rounded-2xl active:scale-95"
          onClick={() => onClick()}
        >
          <div className="mx-auto my-auto text-stone-600 text-md font-bold tablet:py-2 ">
            {name}
          </div>
        </div>
      </div>
      <TablesModal
        openModal={openModal}
        onClose={onClose}
        shopId={shopId}
        table={record.table_assigned}
      />
    </Fragment>
  );
}

export default TableDisplay;
